import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button, Col, Space, Form } from 'antd'
import {
  getHeaders,
  errorNotification,
  deadlineChangesUrl
} from '../../../config'
// import { toast } from 'react-toastify'
import BasicInput from 'components/Forms/BasicInput'
import DatePickerInput from 'components/Forms/DatePickerInput'
// import SelectInput from 'components/Forms/SelectInput'
// import moment from 'moment'
import PropTypes from 'prop-types'

const DeadlineForm = props => {
  const [contact, setContact] = useState({
    reason: '',
    moduleChanged: props.moduleChanged,
    moduleId: props.moduleId,
    newDate: new Date()
  })

  // const [disableForm, setDisableForm] = useState(false)
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  // const [showModal, setShowModal] = useState(false)

  const getClient = () => {
    // setContact(props.user)
  }

  useEffect(() => {
    getClient()
    // eslint-disable-next-line
  }, [])

  const handleInputChange = stateName => event => {
    setContact({ ...contact, [stateName]: event.target.value })
  }

  const handleDateUpdate = stateName => date => {
    setContact({ ...contact, [stateName]: date })
  }

  // const handleSelect = stateName => value => {
  //   setClient({
  //     ...client,
  //     [stateName]: value
  //   })
  // }

  const handleSubmit = event => {
    event.preventDefault()

    setLoading(true)
    axios
      .post(`${deadlineChangesUrl}`, contact, {
        headers: getHeaders()
      })
      .then(res => {
        setLoading(false)
        setContact({
          ...contact,
          reason: ''
        })
        props.handleCancel()
        props.handleSuccess(contact.newDate)
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error creating client contact, retry.')
      })
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="mb-1rem">
            <Form layout="vertical" className="p-2rem">
              <div className="row">
                <div className="col-md-5">
                  <BasicInput
                    label="Reason For Change"
                    value={contact.reason}
                    name={'reason'}
                    placeholder="reason"
                    handleChange={handleInputChange('reason')}
                    required={true}
                  />
                  {serverErrors.reason &&
                    serverErrors.reason.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>

                <div className="col-md-5 offset-md-2 offset-sm-0 ">
                  <DatePickerInput
                    label="New Project Deadline"
                    value={contact.newDate}
                    handleChange={handleDateUpdate('newDate')}
                    name="new date"
                    required={true}
                  />
                  {serverErrors.newDate &&
                    serverErrors.newDate.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>

                {serverErrors.nonFieldErrors &&
                  serverErrors.nonFieldErrors.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}

                <Col md={24}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Space>
                      <Button onClick={() => props.handleCancel()}>
                        Close
                      </Button>
                      <Button
                        type="primary"
                        onClick={handleSubmit}
                        loading={loading}
                      >
                        Submit
                      </Button>
                    </Space>
                  </div>
                </Col>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  )
}

DeadlineForm.propTypes = {
  moduleChanged: PropTypes.string,
  moduleId: PropTypes.string,
  handleCancel: PropTypes.func,
  handleSuccess: PropTypes.func
}

export default DeadlineForm
